// extracted by mini-css-extract-plugin
export default {"title":"ReleaseStatus_title__6lShD"};